import { INgPolymerEvent } from '../../poll_interfaces';
import { IValidationCallbackParams } from './../../types/poll_question_types';

interface IFreeTextQuestionModel {
  text: string;
}

interface IFreeTextFlags {
  hasFocus: boolean;
}

export class FreeTextPollComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-poll/src/components/free_text_poll/free_text_poll.html';
  public controller: any = 'FreeTextPollController';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    question: '<',
    validationCallback: '<?',
    labelledBy: '@'
  };
}

export class FreeTextPollController {
  private models: IFreeTextQuestionModel;
  private flags: IFreeTextFlags;
  private validationCallback: (params: any) => void;

  constructor() {
    this.refresh();
  }

  $onInit(): void {
    this.validationCallback = _.isFunction(this.validationCallback) ? this.validationCallback : angular.noop;
    this.refresh();
  }

  $onChanges(changes: ng.IChangesObject): void {
    this.refresh();
  }

  setFocus(evt: INgPolymerEvent) {
    evt.originalEvent.target.focus();
  }

  refresh(): void {
    this.flags = {
      hasFocus: false
    };

    this.models = {
      text: ''
    };
  }

  updateText(evt: any): void {
    this.textSanitizerAndValidator(evt.originalEvent.detail.value as string);
  }

  textSanitizerAndValidator(text: string): void {
    text = text.replace(/[\\/<>\[\]`\|\/]|\$[a-z]{1,}|\);|\?[a-z]{1,}=[a-z]{1,}|%[a-z0-9]{1,}|&&/gim, '');
    this.models.text = text.trim();

    const textExistsAndIsSaneLength: boolean = text.length < 2500 && text.length > 1;

    this.validationCallback({
      isValid: textExistsAndIsSaneLength,
      selectedResponse: { nk: text, id: undefined }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/components/free_text_poll/free_text_poll.ts